module.exports = __webpack_public_path__ + "img/desert_storm.3bd70b61.png";